import React from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { useIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import PageBuilder from '../PageBuilder/PageBuilder';

import ContactFormSection from './ContactFormSection';

const createContactFormSection = (intl, currentUser) => ({
  sectionType: 'contactForm',
  sectionId: 'contact-form',
  title: {
    fieldType: 'heading2',
    content: intl.formatMessage({ id: 'ContactPage.sectionTitle' }),
  },
  description: {
    fieldType: 'paragraph',
    content: intl.formatMessage({ id: 'ContactPage.sectionDescription' }),
  },
  currentUser,
});

export const ContactPageComponent = props => {
  const { currentUser, pageAssetsData, inProgress, error } = props;
  const intl = useIntl();
  const pageData = pageAssetsData?.contact?.data;
  const sections = [...(pageData?.sections || []), createContactFormSection(intl, currentUser)];

  const fallbackPageAssetsData = {
    sections,
    meta: {
      pageTitle: {
        fieldType: 'plainText',
        content: intl.formatMessage({ id: 'TopbarDesktop.nav.contactUs' }),
      },
    },
  };

  return (
    <PageBuilder
      pageAssetsData={pageData ? { ...pageData, sections } : fallbackPageAssetsData}
      inProgress={inProgress}
      error={error}
      schemaType="Article"
      currentPage="ContactPage"
      options={{
        sectionComponents: {
          contactForm: { component: ContactFormSection },
        },
      }}
    />
  );
};

ContactPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  error: propTypes.error,
  inProgress: bool,
  pageAssetsData: object,
};

const mapStateToProps = state => {
  const { currentUser } = state.user || {};
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};

  return {
    currentUser,
    pageAssetsData,
    inProgress,
    error,
  };
};

const ContactPage = compose(connect(mapStateToProps))(ContactPageComponent);

export default ContactPage;
